import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { getApiUrl } from "../../../utils/baseUrl";
import { Modal } from "react-bootstrap";
import { productDropdownConfig } from "./header-product-linking-dropdown-list";

export default function ProductLinkingDropdown({ parentProductArr, callNavigation, email }) {
  const [getInTouchPopUp, setGetInTouchPopUp] = useState(false);
  const [selectedInactiveProduct, setSelectedInactiveProduct] = useState("");
  const [loading, setLoading] = useState(false);
  const productConfig = productDropdownConfig() || null;

  const onClickSubProducts = (key, url) => {
    callNavigation(key, "", url);
  };

  const handleGetInTouchSubmit = () => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const session_id = userData.session_id || "";
    const expiredProducts = parentProductArr.filter((item) => item.is_subscribed && item.days_left < -1).map((item) => item.product_name);

    const params = {
      planId: session_id || null,
      countries: expiredProducts.join(","),
      key: "All Apps Payments",
      ...(selectedInactiveProduct && { product: selectedInactiveProduct }),
    };

    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        const message = !!res.data && !!res.data.message ? res.data.message : "Something went wrong. Please try again later!";
        !!res.data && !!res.data.status && res.data.status.toUpperCase() === "SUCCESS"
          ? toast.success(selectedInactiveProduct ? "Thanks for showing interest. Your account manager will get in touch with you shortly." : message)
          : toast.error(message);
      })
      .catch(() => toast.error("Something went wrong. Please try again later!"))
      .finally(() => {
        setGetInTouchPopUp(false);
        setSelectedInactiveProduct("");
        setLoading(false);
      });
  };

  const isProductActive = (item) => item.is_subscribed && item.days_left >= 0;

  return (
    <div className="main-container p-2">
      {productConfig &&
        parentProductArr.map((item) => {
          if (item.product_name === "userManagement" || !productConfig[item.product_name]) return null;
          const product = productConfig[item.product_name];
          const handleProductClick = () => {
            if (isProductActive(item)) {
              onClickSubProducts(product.redirectionKey, product.redirectionUrl);
            } else {
              setGetInTouchPopUp(true);
              setSelectedInactiveProduct(item.product_ui_name);
            }
          };

          return (
            <div className="header-product-linking-dropdown-individual-container" key={item.product_name}>
              <div className="d-flex flex-column header-product-linking-dropdown-sub-products-box">
                <div className={`d-flex justify-content-between align-items-center w-100 cursor-pointer`} onClick={handleProductClick}>
                  <div className={`d-flex my-1 align-items-center header-product-linking-dropdown-list-sub-products ${isProductActive(item) ? "enabled" : "disabled"}`}>
                    <img src={product.imageUrl} width={24} height={24} alt={`${item.name}-icon`} className="mr-2" />
                    <div>
                      <div className="title">{item.product_ui_name}</div>
                      <div className="pr-4 desc">{item.product_ui_description}</div>
                    </div>
                  </div>
                  <div>
                    <img
                      src={
                        isProductActive(item)
                          ? "https://res.cloudinary.com/drzta9shk/image/upload/v1694768003/intel/icons/nav_arrow_xsqxgi.svg"
                          : "https://res.cloudinary.com/drzta9shk/image/upload/v1687950013/intel/icons/Lightning-alt_mlxyoq.svg"
                      }
                      alt={isProductActive(item) ? "navigation-arrow" : "lightning"}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      {getInTouchPopUp && (
        <Modal
          show={getInTouchPopUp}
          onHide={() => {
            setGetInTouchPopUp(false);
            setSelectedInactiveProduct("");
          }}
          keyboard={false}
          centered
          className="trademo-modal company-profile-get-in-touch-modal"
        >
          <Modal.Header>
            <Modal.Title>
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" alt="lightning" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4">
            You do not have access to <b>{selectedInactiveProduct}</b>. Connect with your account manager to get access.
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="cancel-button" onClick={() => setGetInTouchPopUp(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary trial-button" onClick={handleGetInTouchSubmit} disabled={loading}>
              Get in Touch
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
